import { Component } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { StateService } from '../services/state.service';

import { State } from '../models/state.model';
import { NotificationService } from '../services/notification.service';

@Component({
  selector: 'app-state-list',
  templateUrl: './state-list.component.html'
})
export class StateListComponent {

  constructor(public service: StateService, private modalService: NgbModal, private notificationService: NotificationService) { }

  ngOnInit() {
    this.onSearch();
  }

  closeResult = '';
  model = new State();
  modelSearch = new State();

  open(content, model) {
    if (model == null)
      model = new State();

    this.model = Object.assign({}, model);
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = 'Closed with: ${result}';
    }, (reason) => {
      this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ${reason}';
    }
  }

  onArchive(id) {
    if (!confirm('Are you sure?')) {
      return;
    }

    this.service.archive(id).subscribe(
      res => {
        this.notificationService.notifySuccess();
      },
      err => { console.log(err); }
    );

  }

  onSearch() {
    this.service.list = null;
    this.service.currentPage = 1;
    this.service.modelSearch = this.modelSearch;
    this.service.search();
  }
}

